import { PANEL } from "./panelTokens";

export const panelBreadcrumbWrapSx = {
  mb: 2,
  px: { xs: 0, sm: 0.25 },
};

export const panelBreadcrumbLinkSx = {
  color: PANEL.text.muted,
  fontSize: "0.8125rem",
  fontWeight: 500,
  textDecoration: "none",
  lineHeight: 1.4,
  "&:hover": {
    color: PANEL.accent.text,
    textDecoration: "underline",
  },
};

export const panelBreadcrumbCurrentSx = {
  color: PANEL.text.primary,
  fontSize: "0.8125rem",
  fontWeight: 700,
  lineHeight: 1.4,
};

export const panelBreadcrumbMutedSx = {
  color: PANEL.text.muted,
  fontSize: "0.8125rem",
  fontWeight: 500,
  lineHeight: 1.4,
};

export const panelBreadcrumbSeparatorSx = {
  color: PANEL.text.label,
  fontSize: "1rem",
};
